import Heading from "@/components/tpr/Heading/Heading";

// import { Item, ItemActions, ItemContent, ItemDescription, ItemTitle } from "@/components/ui/item";
// import { useMember } from "@/contexts/memberContext";

const AcceptableUsePolicyView = () => {
  // const { member } = useMember();
  return (
    <div>
      <div className="px-4 min-h-[80vh]">
        <div className="mb-8 mt-8">
          <Heading title={`Acceptable Use Policy`} />
        </div>

        <section className="text-gray-600 body-font pt-4 pb-1">
          <div className="container px-5 mt-4 mb-8 mx-auto flex flex-wrap">
            <a
              href="/terms"
              className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium bg-indigo-800 text-white hover:cursor-pointer"
            >
              👈 See all our terms &amp; conditions
            </a>
          </div>
        </section>

        <section className="text-gray-600 body-font">
          <div className="container px-5 py-4 mx-auto flex flex-wrap">
            <p className="text-base">These are not the terms or conditions that apply to our products.</p>
          </div>
        </section>

        <section className="text-gray-600 body-font">
          <div className="container px-5 py-12 mx-auto flex flex-wrap">
            <h2 className="text-1xl text-gray-900 font-medium title-font mb-2 md:w-1/5 leading-none">General</h2>
            <div className="md:w-4/5 md:pl-6">
              <ol>
                <li className="leading-relaxed text-base mb-4">
                  The terms "we", "us", or "our", refer to The Practice Rooms Ltd.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  The Practice Rooms Ltd is registered at Suite 8, Westbury Court, Church Road, Bristol, BS9 3EF,
                  company registration number 7311013. Registered office: Suite 8, Westbury Court, Church Road,
                  Bristol, BS9 3EF.
                </li>
                <li className="leading-relaxed text-base mb-4">These terms and conditions have no fixed duration.</li>
              </ol>
            </div>

            <h2 className="text-1xl text-gray-900 font-medium title-font mb-2 md:w-1/5 leading-none">
              Accessing our site
            </h2>
            <div className="md:w-4/5 md:pl-6">
              <ol>
                <li className="leading-relaxed text-base mb-4">
                  Access to our site is permitted on a temporary basis, and we reserve the right to withdraw, suspend,
                  amend the service we provide on our site without notice (see below) or close it indefinitely. We will
                  not be liable if for any reason our site is unavailable at any time or for any period.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  From time to time, we may restrict access to some parts of our site, or our entire site, to users who
                  have registered with us.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  If you choose, or you are provided with, a user identification code, password or any other piece of
                  information as part of our security procedures, you must treat such information as confidential, and
                  you must not disclose it to any third party. We have the right to disable any user identification code
                  or password, whether chosen by you or allocated by us, at any time, if in our opinion you have failed
                  to comply with any of the provisions of these terms and conditions.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  You are responsible for making all arrangements necessary for you to have access to our site. You are
                  also responsible for ensuring that all persons who access our site through your internet connection
                  are aware of these terms, and that they comply with them.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  We process information about you in accordance with our{" "}
                  <a href="/terms/privacy" className="text-purple-600 hover:cursor-pointer">
                    Privacy Policy
                  </a>
                  .
                </li>
                <li className="leading-relaxed text-base mb-4">
                  We aim to update our site regularly, and may change the content at any time. Any of the material on
                  our site may be out of date at any given time, and we are under no obligation to update such material.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  We try to meet highest standards of accessibility, but cannot guarantee that this site will be
                  compatible with all hardware and software that may be used by visitors to the site.
                </li>
              </ol>
            </div>

            <h2 className="text-1xl text-gray-900 font-medium title-font mb-2 md:w-1/5 leading-none">Materials</h2>
            <div className="md:w-4/5 md:pl-6">
              <ol>
                <li className="leading-relaxed text-base mb-4">
                  All copyrights, trademarks, patents, design rights, and other intellectual property rights relating to
                  our site and the materials published on it (including, but not limited to, the underlying software,
                  the design, graphics, layout, feel, and structure of our sites) will be and remain the sole property
                  of us or our licensors. Those works are protected by copyright laws and treaties around the world. All
                  such rights are reserved.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  You may view, use, download, print off one copy and store the material on this site for personal use
                  only and you may draw the attention of others within your organisation to material posted on our site.
                  Commercial use is not permitted unless you have obtained a licence to use materials on our site for
                  commercial purposes. Redistributing, republishing, copying, adapting the paper or digital copies of
                  any materials you have printed off or downloaded in any way or otherwise making material on this site
                  available to third parties is prohibited. You must not use any illustrations, photographs, video or
                  audio sequences or any graphics separately from any accompanying text.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  Our status (and that of any identified contributors) as the authors of material on our site must
                  always be acknowledged.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  If you print off, copy or download any part of our site in breach of these terms of use, your right to
                  use our site will cease immediately and you must, at our option, return or destroy any copies of the
                  materials you have made.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  The information in this website is given in good faith and for general information and interest only.
                  It is subject to change without notice. We make every effort to ensure that the information on our
                  websites is correct but we cannot guarantee that it is 100% free of inaccuracies, errors and
                  omissions.
                </li>
              </ol>
            </div>

            <h2 className="text-1xl text-gray-900 font-medium title-font mb-2 md:w-1/5 leading-none">Our Liability</h2>
            <div className="md:w-4/5 md:pl-6">
              <ol>
                <li className="leading-relaxed text-base mb-4">
                  Users of this site are responsible for any decisions they take based on information provided on the
                  site and commentary and other materials on our site are not intended to amount to advice on which
                  reliance should be placed. You should consult your professional advisers before taking any action
                  based on the content of our site. We disclaim all responsibility and liability (as far as legally
                  permitted) for any loss (directly or indirectly) arising from using or relying on information or links
                  included in this site.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  Our sites may contain links to other sites, which are provided for your information only. The contents
                  of those sites or resources are outside our control and are not covered by these terms and conditions.
                  If you access other sites using the links provided, we accept no responsibility for the content of
                  those sites, for the way in which they deal with you or use any information they may acquire about you
                  or for any loss or damage that may arise from your use of them.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  The material displayed on our site is provided without any representations, guarantees, conditions or
                  warranties as to its accuracy, completeness or that the content is up-to-date. To the extent permitted
                  by law, we, other members of our group of companies and third parties connected to us hereby expressly
                  exclude:
                  <ol className="mt-4 ml-8 space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400">
                    <li>
                      all conditions, warranties and other terms which might otherwise be implied by statute, common law
                      or the law of equity;
                    </li>
                    <li>
                      any liability for any direct, indirect or consequential loss or damage incurred by any user in
                      connection with our site or in connection with the use, inability to use, or results of the use of
                      our site, any websites linked to it and any materials posted on it, includind but not limited to:
                      loss of income or revenue; b) loss of business, loss of business opportunity or other economic
                      loss; c) loss of profits or contracts; d) loss of anticipated savings; e) loss or corruption of
                      data; f) loss of goodwill; g) business interruption, wasted management or office time; and in all
                      the above cases, whether caused by tort (including negligence), breach of contract or otherwise,
                      even if foreseeable.
                    </li>
                  </ol>
                </li>
                <li className="leading-relaxed text-base mb-4">
                  These terms and conditions do not exclude our liability (if any) to you for personal injury or death
                  resulting from our negligence, or our liability for fraud, nor any other liability which cannot be
                  excluded or limited under applicable law and do not affect your statutory rights.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  Arrangements made between you and any third party named or referred to on the site are entirely at
                  your sole risk and responsibility.
                </li>
              </ol>
            </div>

            <h2 className="text-1xl text-gray-900 font-medium title-font mb-2 md:w-1/5 leading-none">Your Liability</h2>
            <div className="md:w-4/5 md:pl-6">
              <ol>
                <li className="leading-relaxed text-base mb-4">
                  You shall compensate us in full if we incur any losses or if any claims or legal proceedings are
                  brought or threatened against us by any other person arising from your use of our website, as well as
                  any information uploaded by you on our site.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  You agree to indemnify and hold us harmless from any liability, loss, claim, and expense (including
                  reasonable legal fees) related to any breach by you of these terms and conditions or arising from your
                  use of our site, including any information uploaded by you on our site.
                </li>
              </ol>
            </div>

            <h2 className="text-1xl text-gray-900 font-medium title-font mb-2 md:w-1/5 leading-none">
              Uploading material
            </h2>
            <div className="md:w-4/5 md:pl-6">
              <ol>
                <li className="leading-relaxed text-base mb-4">
                  Whenever you make use of a feature that allows you to upload material to our site, or to make contact
                  with other users of our site, you must comply with the content standards set out in our acceptable use
                  policy. You warrant that any such contribution does comply with those standards, and you indemnify us
                  for any breach of that warranty.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  We will not be responsible, or liable to any third party, for the content or accuracy of any materials
                  posted by you or any other user of our site. Such information has not been verified or approved by us
                  nor represent our views and values.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  We have the right to remove any material or posting you make on our site if, in our opinion, such
                  material does not comply with the content standards set out in our acceptable use policy.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  If you upload any material on our site that is in breach of any intellectual property or privacy
                  rights, we have the right to disclose your identity to the third party claiming such breach.
                </li>
              </ol>
            </div>

            <h2 className="text-1xl text-gray-900 font-medium title-font mb-2 md:w-1/5 leading-none">
              Viruses, hacking &amp; other offences
            </h2>
            <div className="md:w-4/5 md:pl-6">
              <ol>
                <li className="leading-relaxed text-base mb-4">
                  You must not misuse our site by knowingly introducing viruses, Trojans, worms, logic bombs or other
                  material which is malicious or technologically harmful. You must not attempt to gain unauthorised
                  access to our site, the server on which our site is stored or any server, computer or database
                  connected to our site. You must not attack our site via a denial-of-service attack or a distributed
                  denial-of service attack.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  By breaching this provision, you would commit a criminal offence under the Computer Misuse Act 1990.
                  We will report any such breach to the relevant law enforcement authorities and we will co-operate with
                  those authorities by disclosing your identity to them. In the event of such a breach, your right to
                  use our site will cease immediately.
                </li>
                <li className="leading-relaxed text-base mb-4">
                  We will not be liable for any loss or damage caused by a distributed denial-of-service attack, viruses
                  or other technologically harmful material that may infect your computer equipment, computer programs,
                  data or other proprietary material due to your use of our site or to your downloading of any material
                  posted on it, or on any website linked to it.
                </li>
              </ol>
            </div>

            <h2 className="text-1xl text-gray-900 font-medium title-font mb-2 md:w-1/5 leading-none">
              Jurisdiction and applicable law
            </h2>
            <div className="md:w-4/5 md:pl-6">
              <ol>
                <li className="leading-relaxed text-base mb-4">
                  The English courts will have exclusive jurisdiction over any claim arising from, or related to, a
                  visit to our site, these terms of use and their subject matter (including any non-contractual
                  obligations arising out of or in connection with it).
                </li>
                <li className="leading-relaxed text-base mb-4">
                  These terms of use and any dispute or claim arising out of or in connection with them or their subject
                  matter or formation (including non-contractual disputes or claims) shall be governed by and construed
                  in accordance with the law of England and Wales.
                </li>
              </ol>
            </div>

            <h2 className="text-1xl text-gray-900 font-medium title-font mb-2 md:w-1/5 leading-none">Variations</h2>
            <div className="md:w-4/5 md:pl-6">
              <ol>
                <li className="leading-relaxed text-base mb-4">
                  We reserve the right to change these terms and conditions from time to time, and the amended terms
                  will be posted on this website. You are expected to check this page from time to time to take notice
                  of any changes we make, as they are binding on you. Some of the provisions contained in these terms of
                  use may also be superseded by provisions or notices published elsewhere on our site.
                </li>
              </ol>
            </div>
            <p className="text-base">Last updated April 2025.</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AcceptableUsePolicyView;
